import { compile } from 'path-to-regexp';
import { getApp } from './get-app';
/**
 * Builds a content path based on the given identifier, path parameters and query parameters.
 * @param identifier The identifier of the content builder.
 * @param params The path parameters to use when building the path.
 * @returns The full content path with query parameters.
 */
export function getContentBuilder(identifier, params) {
    const appConfig = getApp();
    if (!appConfig) {
        console.error('Application configuration not found.');
        return;
    }
    const { baseHref, hash, contentBuilders } = appConfig;
    const routeBuilder = createRouteBuilder(identifier, contentBuilders);
    if (!routeBuilder) {
        return;
    }
    let path = routeBuilder(params);
    // Remove leading slash
    path = path.startsWith('/') ? path.slice(1) : path;
    const url = new URL(path, baseHref);
    url.searchParams.append('v', hash);
    return url.toString();
}
function createRouteBuilder(identifier, contentBuilders) {
    const contentPath = contentBuilders === null || contentBuilders === void 0 ? void 0 : contentBuilders[identifier];
    if (!contentPath) {
        console.error(`Content builder "${identifier}" not found.`);
        return;
    }
    return compile(contentPath);
}
